<template>
  <el-container class="gWidth">
    <el-aside width="200px">
      <el-menu
        :background-color="'#d3dce6'"
        :default-active="active"
        class="el-menu-vertical-demo"
        router
      >
        <el-sub-menu index="account">
          <template #title>
            <span>账户管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="message">个人信息</el-menu-item>
            <el-menu-item index="wallet">我的钱包</el-menu-item>
            <!-- <el-menu-item index="goldpay">我的充值</el-menu-item> -->
          </el-menu-item-group>
        </el-sub-menu>
        <el-sub-menu index="dynamic">
          <template #title>
            <span>我的动态</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="manner">我的分析</el-menu-item>
            <el-menu-item index="select">我的推单</el-menu-item>
            <el-menu-item index="article">我的文章</el-menu-item>
            <el-menu-item index="collect">我的收藏</el-menu-item>
            <el-menu-item index="purchase">我的购买</el-menu-item>
            <el-menu-item v-if="AUTH_TOKEN?.is_kan_print" index="release"
              >新闻发布</el-menu-item
            >
            <el-menu-item v-if="AUTH_TOKEN?.is_kan_print" index="incident"
              >战报发布</el-menu-item
            >
          </el-menu-item-group>
        </el-sub-menu>
        <el-sub-menu index="help_f">
          <template #title>
            <span>帮助反馈</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="help">帮助中心</el-menu-item>
            <el-menu-item index="feedback">反馈中心</el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>
      </el-menu>
    </el-aside>
    <el-main>
      <router-view v-if="isToken" :token="isToken" :AUTH_OBJ="AUTH_OBJ" />
    </el-main>
  </el-container>
</template>
<script>
import { getCurrentInstance, ref, watch } from "vue";
import { useRouter } from "vue-router";
export default {
  setup() {
    let { proxy: _this } = getCurrentInstance();
    let active = ref("message");
    let router = useRouter();
    active.value = router.currentRoute.value.name;
    // 判断路由高亮
    watch(
      () => router.currentRoute.value.name,
      (n) => {
        active.value = n;
      }
    );
    // 用户信息
    let AUTH_OBJ = ref({});
    let user_fn = async () => {
      let { data: res } = await _this.$http.get(`/auth/user`);
      AUTH_OBJ.value = res.data;
    };
    // 判断是否登录
    let isToken = ref(false);
    let AUTH_TOKEN = ref(JSON.parse(window.localStorage.getItem("AUTH_TOKEN")));
    if (AUTH_TOKEN.value) {
      user_fn(AUTH_TOKEN.value.user_id);
      isToken.value = AUTH_TOKEN.value.token;
    }
    return {
      active,
      isToken,
      AUTH_OBJ,
      AUTH_TOKEN,
    };
  },
};
</script>

<style scoped lang="less">
.el-aside {
  background: #d3dce6;
}
.el-main {
  background: #fff;
}
.is-active {
  background: #fff;
}
</style>
